<template>
  <vx-card v-if="roles && userRoles" no-shadow>
    <h2 class="mb-6">User - Roles</h2>

    <vs-row>
      <div
        v-if="hasPermission('life.admin.user.roles.assignRole')"
        @click="onAssignToRole"
        class="
          btn-add-new
          p-3
          mb-4
          mr-4
          rounded-lg
          cursor-pointer
          flex
          items-center
          justify-center
          text-lg
          font-medium
          text-base text-primary
          border border-solid border-primary
        "
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Assign role</span>
      </div>
      <div class="mr-auto mt-auto mb-auto">
        <vs-checkbox v-model="showDeactivated">Show deactivated roles</vs-checkbox>
      </div>
    </vs-row>

    <vs-row>
      <div v-for="userRole in userRoles" :key="userRole.id">
        <vs-col
          class="rolecard p-3"
          v-if="
            !(
              !showDeactivated &&
              (userRole.isDeactivated ||
                new Date().getTime() > moment(userRole.validToDate).toDate().getTime())
            )
          "
          :class="{
            deactivated:
              userRole.isDeactivated ||
              new Date().getTime() > moment(userRole.validToDate).toDate().getTime(),
          }"
        >
          <vs-card>
            <div slot="header">
              <vs-row vs-justify="space-between">
                <h6>{{ userRole.title }} ({{ userRole.roleId }})</h6>
                <div v-if="userRole.isDeactivated">
                  <vs-chip color="danger">DEACTIVATED</vs-chip>
                </div>
                <div
                  v-if="
                    !userRole.isDeactivated &&
                    new Date().getTime() > moment(userRole.validToDate).toDate().getTime()
                  "
                >
                  <vs-chip color="danger">EXPIRED</vs-chip>
                </div>
                <div
                  v-if="
                    !userRole.isDeactivated &&
                    new Date().getTime() < moment(userRole.validToDate).toDate().getTime()
                  "
                >
                  <feather-icon
                    v-if="hasPermission('life.admin.user.roles.deactivateRole')"
                    icon="XIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="deleteData(userRole.id)"
                  />
                </div>
              </vs-row>
            </div>
            <div>
              <vs-row>
                <vs-col vs-w="4">Role limited to</vs-col>
                <vs-col vs-w="8"
                  ><b
                    >{{ userRole.entityType == 0 ? "Nothing" : entityTypeMap[userRole.entityType]
                    }}<i>{{ userRole.entityType == 0 ? "" : ": " + userRole.entityInstanceName }}</i></b
                  ></vs-col
                >
              </vs-row>
              <vs-row>
                <vs-col vs-w="4">Valid from</vs-col>
                <vs-col vs-w="8"
                  ><b>{{ moment(userRole.validFromDate).format("DD-MM-YYYY") }}</b></vs-col
                >
              </vs-row>
              <vs-row>
                <vs-col vs-w="4">Valid to</vs-col>
                <vs-col vs-w="8">
                  <b>
                    {{
                      userRole.isDeactivated
                        ? moment(userRole.deactivatedDate).format("DD-MM-YYYY HH:mm:ss")
                        : userRole.validToDate === null
                        ? "Never"
                        : moment(userRole.validToDate).format("DD-MM-YYYY")
                    }}
                  </b>
                </vs-col>
              </vs-row>
            </div>
            <div slot="footer" class="rolecard-footer">
              <vs-row>
                <span
                  >Assigned <b>{{ moment(userRole.createdDate).format("DD-MM-YYYY") }}</b></span
                >
                <span
                  >&nbsp;by <b>{{ userRole.createdByDisplayName }}</b></span
                >
              </vs-row>
            </div>
            <!-- <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button type="gradient" color="danger" icon="favorite"></vs-button>
              <vs-button color="primary" icon="turned_in_not"></vs-button>
              <vs-button color="rgb(230,230,230)" color-text="rgb(50,50,50)" icon="settings"></vs-button>
            </vs-row>
          </div> -->
          </vs-card>
        </vs-col>
      </div>
    </vs-row>

    <vs-popup title="Assign role to User" :active.sync="assignToRolePopupActive" id="addRolePopup">
      <div>
        <p class="mb-2">Select Role:</p>
        <vs-select class="mb-5" v-model="selectedRole" @change="onRoleSelected()">
          <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item, index) in roles" />
        </vs-select>

        <div class="vx-col sm:w-1/5 w-full">
          <span>Valid between</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="display: flex">
          <div class="my-4">
            <small class="date-label">From</small>
            <flat-pickr
              :config="datePickerOptions"
              v-model="startDate"
              placeholder="Start..."
              style="display: flex"
            />
          </div>

          <div class="my-4" style="margin-left: 8px">
            <small class="date-label">To</small>
            <flat-pickr
              :config="datePickerOptions"
              v-model="endDate"
              placeholder="End..."
              style="display: flex"
            />
          </div>
        </div>

        <div v-if="selectedRole != null && selectedRoleModel.entityType > 0">
          <p>A role will be assigned for each selected entity</p>
          <p>Select at least one entity</p>

          <vs-row>
            <vs-col vs-w="6">
              <vs-table
                v-if="selectedRole !== null"
                class="role-table left"
                :data="getEntities"
                @selected="onEntitySelected"
              >
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-name font-medium truncate">
                          {{ tr.name }}
                        </p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vs-col>

            <vs-col vs-w="6" class="px-4">
              <vs-table
                v-if="selectedRole !== null"
                class="role-table right"
                :data="selectedEntities"
                @selected="onRightEntitySelected"
              >
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="'success'">
                      <vs-td>
                        <p class="product-name font-medium truncate">
                          {{ tr.name }}
                        </p>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>

              <!-- <vs-row v-for="entity in selectedEntities" :key="entity.id">
                <vs-button class="mt-2" color="success" type="filled" icon-pack="feather">
                  {{ entity.name }}
                </vs-button>
              </vs-row> -->
            </vs-col>
          </vs-row>
        </div>
        <vs-button
          :disabled="selectedEntities.length == 0"
          @click="assignRolesToUser"
          class="mt-10"
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="done"
        >
          Assign
        </vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

export default {
  components: {
    flatPickr,
  },
  data() {
    return {
      showDeactivated: false,
      moment,
      momentFormat: "DD-MM-YYYY",
      roleToDeactivate: "",
      userId: null,
      startDate: moment(new Date()).add(1, "S").toDate(), // 1 second
      endDate: moment(new Date()).add(10, "Y").toDate(), // 10 years

      selected: null,
      countryEntities: [
        {
          id: "dk",
          name: "Denmark",
        },
        {
          id: "no",
          name: "Norway",
        },
        {
          id: "fi",
          name: "Finland",
        },
        {
          id: "uk",
          name: "United Kingdom",
        },
      ],
      userRoles: null,
      roles: null,

      selectedEntities: [],
      entityTypeMap: ["Nothing", "Venue", "Country", "Region"],
      assignToRolePopupActive: false,

      assignmentVenues: null,
      selectedRole: null,
      datePickerOptions: {
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        //minDate: new Date(),
        dateFormat: "d-m-Y",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
      },
    };
  },
  methods: {
    onAssignToRole: function () {
      this.getVenues();

      this.selectedEntities = [];
      this.assignToRolePopupActive = true;
    },

    onRoleSelected: function () {
      console.log("onRoleSelected");
      this.selectedEntities = []; // Reset so we cannot pick an entity belonging to another role
    },

    onEntitySelected: function (entity) {
      console.log("onEntitySelected", entity);
      if (!this.selectedEntities.includes(entity)) this.selectedEntities.push(entity);
    },

    onRightEntitySelected: function (entity) {
      console.log("onRightEntitySelected", entity);
      this.selectedEntities = this.selectedEntities.filter(e => e.id != entity.id);
    },

    async assignRolesToUser() {
      this.$vs.loading();

      console.log(this.selectedEntities);

      await Promise.all(
        this.selectedEntities.map(async element => {
          const payload = {
            userId: this.userId,
            roleId: this.selectedRoleModel.id,
            validFromDate:
              typeof this.startDate === "string"
                ? moment.utc(this.startDate, this.momentFormat).toDate()
                : this.startDate,
            validToDate:
              typeof this.endDate === "string"
                ? moment.utc(this.endDate, this.momentFormat).toDate()
                : this.endDate,
            entityInstance: this.selectedRoleModel.entityType > 0 ? element.id : "", // Legacy for roles that were not bound to an entity
            entityInstanceName: this.selectedRoleModel.entityType > 0 ? element.name : "",
          };

          console.log("Assigning role to role", payload);

          try {
            await this.$http.post(process.env.VUE_APP_API + "/Idam/User/Roles/AssignRole", payload);
          } catch (err) {
            console.error("Error assigning role", element, err);
          }
        }),
      );

      this.assignToRolePopupActive = false;
      this.selectedEntities = [];
      this.selectedRole = null;
      this.getUser();
      this.$vs.loading.close();
    },

    removeFromRole: function () {
      this.$vs.loading();

      const payload = {
        roleInstanceId: this.roleToDeactivate,
      };

      console.log("Removing user from role", payload);

      this.$http
        .post(process.env.VUE_APP_API + "/Idam/User/Roles/DeactivateRole", payload)
        .then(() => {
          this.getUser();
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getVenues: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/venues?query=*")
        .then(resp => {
          this.assignmentVenues = resp.data.map(e => {
            return { ...e, id: e.venueId };
          });
          console.log(this.assignmentVenues);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getAllRoles: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Idam/Roles")
        .then(resp => {
          this.roles = resp.data;
          console.log("Roles", this.roles);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getRegions: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Idam/Region")
        .then(resp => {
          this.regions = resp.data;
          this.regions = this.regions.map(e => {
            return { ...e, name: `${e.number} (${e.name})` };
          });
          console.log("Regions", this.regions);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getUser: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Idam/User/Roles/" + this.userId)
        .then(resp => {
          this.userRoles = resp.data;
          console.log("Got user roles", this.userRoles);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onRoleClicked(role) {
      console.log("clicked role", role);
    },

    deleteData(roleId) {
      this.roleToDeactivate = roleId;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to deactivate this role?",
        accept: this.removeFromRole,
      });
    },
  },
  computed: {
    getEntities() {
      let entities = [];

      switch (this.selectedRoleModel.entityType) {
        case 1:
          entities = this.assignmentVenues;
          break;
        case 2:
          entities = this.countryEntities;
          break;
        case 3:
          entities = this.regions;
          break;
      }

      return entities.filter(e => !this.selectedEntities.some(se => se.id == e.id));
    },
    selectedRoleModel() {
      return this.selectedRole ? this.roles.filter(e => e.id === this.selectedRole)[0] : null;
    },
  },
  created() {
    this.getAllRoles();
    this.getRegions();
    this.userId = this.$route.params.userId;
    this.getUser();
  },
};
</script>

<style lang="scss">
#addRolePopup.con-vs-popup .vs-popup {
  width: 940px !important;
  max-width: 80vw !important;
}

.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>